import styled, { css } from 'styled-components';

import { media } from 'utils/detection';

export default styled.a`
  position: relative;
  display: inline-block;
  color: ${props => (props.dark ? props.theme.textDark : props.theme.textLight)};
  font-family: 'Galano Classic';
  font-size: 21px;
  font-weight: 400;
  text-decoration: none;
  cursor: pointer;

  ${media.medium`
    font-size: 2.5vw;
  `}

  ${props =>
    props.isBack &&
    css`
      &::after {
        content: '';
        position: absolute;
        display: block;
        width: 42px;
        height: 1px;
        top: 50%;
        right: 100%;
        margin: 0 16px 0 0;
        background-color: ${props => (props.dark ? props.theme.textDark : props.theme.textLight)};

        ${media.medium`
          left: auto;
          right: 100%;
          width: 84px;
          margin: 0 22px 0 0;
        `}
      }
    `}

  ${props =>
    !props.isBack &&
    css`
      &::after {
        content: '';
        position: absolute;
        display: block;
        width: 42px;
        height: 1px;
        top: 50%;
        left: 100%;
        margin: 0 0 0 16px;
        background-color: ${props => (props.dark ? props.theme.textDark : props.theme.textLight)};

        ${media.medium`
          left: 100%;
          right: auto;
          width: 84px;
          margin: 0 0 0 22px;
        `}
      }
    `}
`;
